import React from "react";
import Footer from "../components/core/Footer";
import HeaderFbAd from "../components/core/HeaderFbAd";
import BannerFbAd from "../components/app/sections/BannerFbAd";
import Features from "../components/app/sections/Features";
import GetStartedCard from "../components/app/sections/GetStartedCard";
import Plan from "../components/app/sections/Plan";
import Amazon from "../components/app/sections/Amazon";
import Companies from "../components/app/sections/Companies";
import Testimonials from "../components/app/sections/Testimonials";
import InteractiveDemo from "../components/app/sections/InteractiveDemo";
import HowItWorks from "../components/app/sections/HowItWorks";
import useScrollToTop from "../hooks/useScrollToTop";
import SEOHead from "../components/seo/SEOHead";

const LandingFbAd = () => {
  useScrollToTop();

  return (
    <div>
      <SEOHead
        title="Amazon Customization Sync for ShipStation & Veeqo"
        description="Sync Amazon order customization text and images to ShipStation or Veeqo automatically. Start your free trial."
        keywords="Amazon customization sync, ShipStation, Veeqo, e-commerce automation, high volume sellers"
        type="website"
        url="https://customsync.app/lp/facebook"
      />
      <HeaderFbAd />
      <div className="overflow-x-hidden">
        <BannerFbAd />
        <Testimonials />
        <InteractiveDemo />
        <HowItWorks />
        <Companies />
        <Features />
        <Amazon />
        <Plan />
        <GetStartedCard />
        <Footer />
      </div>
    </div>
  );
};

export default LandingFbAd;
